export default [
    // French
    'fr/home/template',

    // English
    'en/home/template'
]



// WEBPACK FOOTER //
// ./src/companies/default/lang/conf.js